// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-body_root__B8v82","disablePadding":"modal-body_disablePadding__bY7uR"};